export {
    emptyCompanyForm,
    emptyEmployeeForm,
    emptyEditEmployeeForm,
    emptyEmployeeSelfForm,
} from '../../utils/profileFormMaps';

export const emptyTaskForm = {
    title: '',
    summary: '',
    employeeId: '',
    amount: '',
    dueDate: '',
    category: '',
    skills: '',
    acceptanceCriteria: '',
};

export const formFieldClass = 'cpg-input';
